import { useEffect } from 'react'
import { treeify } from '../../../common/Helpers';
import { getSecurityProps, getUsersByElementId } from '../../../services/Auth/user.service';
import { getPrivilegeActions, getPrivilegeMatrix, getPrivilegeRoles, getReportClientLogo } from '../../../services/sPrivilege/privilege.service';
import { __OBJECT_STRUCTURE_GetPrivilegeMatrix } from '../../../common/ObjectStructures/sKPI';
import { useTranslation } from 'react-i18next';

const NO_ACCESS_PATH = '/NoDataAccess';
const isNoAccessPath = () => {
    return window.location.pathname.toLowerCase() === NO_ACCESS_PATH;
};

const useGetSecurityProps = (auxCurrentToken, securityProps, setSecurityProps, skipSecurityValidation ) => {    
    useEffect(() => {
        const getData = async () => {
            try {
                const userName = auxCurrentToken && auxCurrentToken.userName ? auxCurrentToken.userName : null;

                if (!userName) {
                    setSecurityProps(false);
                    return;
                }

                const cleanUserName = userName.indexOf('\\') !== -1 ? userName.split('\\')[1] : userName;

                let serviceResponse = await getSecurityProps(cleanUserName);
                const response = serviceResponse;

                if (response.data.succeeded) {
                    const profile = Array.isArray(auxCurrentToken.profile) ? auxCurrentToken.profile : [];

                    const products = Array.isArray(response.data.data.l_products) ? response.data.data.l_products : [];

                    setSecurityProps({
                        ...response.data.data,
                        isSAdmin: profile.filter(x => x === "sAdmin").length > 0,
                        l_products: [...products, 'BASE']
                    });
                }
                else {
                    setSecurityProps(false);
                }
            }
            catch (error) {
                setSecurityProps(false);
            }
        };
        
        if (skipSecurityValidation === true || isNoAccessPath()) {
            return;
        }

        if (auxCurrentToken !== null && auxCurrentToken.userName !== null && securityProps === null) {
            getData();
        }
    }, [auxCurrentToken, securityProps, setSecurityProps, skipSecurityValidation]);
}

const useGetUsersByElementId = (elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, forceUpdate, isTreeify) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsersByElementId(elementId);

                if (serviceResponse.data.succeeded) {
                    if (isTreeify) {
                        serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children', "fullName", 'emailUser');

                        if (selectInitialData) {
                            serviceResponse.forEach(element => {
                                initialIdsDataArray.forEach(id => {
                                    if (element.id === id) {
                                        element.checked = true;
                                    }
                                });
                            });
                        }
                        
                        setUsersArray && setUsersArray(serviceResponse)
                    }
                    else {
                        setUsersArray && setUsersArray(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: serviceResponse.data.data
                        }));
                    }
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                if (isTreeify) {
                    setUsersArray && setUsersArray([])
                }
                else {
                    setUsersArray && setUsersArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
        }
        
        if (elementId !== null && ((usersArray === null || forceUpdate) && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }
    }, [elementId, usersArray, setUsersArray, selectInitialData, initialIdsDataArray, isPanelOpen, forceUpdate, isTreeify]);
}

const useGetPrivilegeMatrix = (auxCurrentToken, privilegeMatrix, setPrivilegeMatrix, setRowList) => {    
    const { t } = useTranslation();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponseMatrix = await getPrivilegeMatrix();
                let serviceResponseRoles = await getPrivilegeRoles();
                let serviceResponseActions = await getPrivilegeActions();

                const responseMatrix = serviceResponseMatrix;
                const responseRoles = serviceResponseRoles;
                const responseActions = serviceResponseActions;
                
                let objPrivilege = {matrix: null, roles: null, actions: null};

                if (responseMatrix.data.succeeded) {
                    objPrivilege.matrix = responseMatrix.data.data;

                    if (responseRoles.data.succeeded) {
                        objPrivilege.roles = responseRoles.data.data;
                    }

                    if (responseActions.data.succeeded) {
                        objPrivilege.actions = responseActions.data.data;
                    }
                }
                else {
                    objPrivilege = null
                }

                setRowList && setRowList(objPrivilege.matrix.l_matrix.map(elemento => {
                    return {
                        ...elemento,
                        privilegeAppElementName: t(elemento.privilegeAppElementName)
                    };
                }));

                setPrivilegeMatrix && setPrivilegeMatrix(objPrivilege);
            }
            catch (error) {
                setPrivilegeMatrix && setPrivilegeMatrix(null);
            }
        }
        
        if (auxCurrentToken !== null && auxCurrentToken.userName !== null && privilegeMatrix !== null && privilegeMatrix.matrix === null) {
            getData()
        }
    }, [auxCurrentToken, privilegeMatrix, setPrivilegeMatrix, setRowList]);
}


const useGetReportClientLogo = (logo, setLogo) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponseMatrix = await getReportClientLogo();

                const response = serviceResponseMatrix;
                
                if (response.data.succeeded) {
                    setLogo && setLogo(response.data.data);
                }
                else {
                    setLogo && setLogo(null);
                }
            }
            catch (error) {
                setLogo && setLogo(null);
            }
        }
        
        if (logo === undefined) {
            getData()
        }
    }, [logo, setLogo]);
}

export {
    useGetSecurityProps,
    useGetUsersByElementId,
    useGetPrivilegeMatrix,
    useGetReportClientLogo
}